export default __webpack_public_path__ + "static/media/img666.f0645cee.png";